import { createIcon } from '@chakra-ui/icons';

export const AuthoringGrayScorm = createIcon({
  displayName: 'AuthoringGrayScorm',
  viewBox: '0 0 44 44',
  path: [
    <svg width="44" height="45" viewBox="0 0 44 45" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4794_23156)">
        <path
          d="M0.655273 22.8899C0.655273 39.3208 18.4423 49.5902 32.6719 41.3747C39.2759 37.5619 43.3441 30.5155 43.3441 22.8899C43.3441 6.459 25.5571 -3.81036 11.3275 4.40514C4.72347 8.21795 0.655273 15.2643 0.655273 22.8899Z"
          fill="#F6F6F6"
        />
        <path
          d="M18.2258 22.4396L15.3635 27.449C15.0167 28.0557 15.4548 28.8107 16.1536 28.8106H19.7146C20.33 28.8101 20.7682 29.4083 20.5822 29.995L18.9606 35.131C18.8544 35.4646 19.1492 35.788 19.4912 35.7131C19.5933 35.6908 19.6846 35.634 19.7497 35.5522L26.1445 27.559C26.5821 27.0115 26.2629 26.1956 25.5699 26.0904C25.5249 26.0836 25.4795 26.0801 25.434 26.0801H23.7943C23.1177 26.0802 22.6777 25.368 22.9805 24.7629L24.1421 22.4375L18.2258 22.4396Z"
          fill="white"
          stroke="#535353"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.225 14.1798C32.8878 11.4719 30.3708 9.06201 27.6944 9.84186C27.2626 9.96766 26.8581 10.1728 26.5014 10.4467C22.8772 6.17482 15.9876 7.42814 14.1001 12.7028C13.8181 13.4906 13.6742 14.3212 13.6746 15.158V15.2045C13.5233 15.179 13.3706 15.1634 13.2173 15.158C10.4148 15.155 8.65998 18.1868 10.0586 20.6154C10.7091 21.7449 11.9138 22.4404 13.2173 22.439H29.5983C33.0966 22.4462 35.2908 18.6639 33.5479 15.6307C33.2179 15.0564 32.7664 14.5612 32.225 14.1798Z"
          fill="#A0A0A0"
        />
        <path
          d="M32.225 14.1798C32.8878 11.4719 30.3708 9.06201 27.6944 9.84186C27.2626 9.96766 26.8581 10.1728 26.5014 10.4467C22.8772 6.17482 15.9876 7.42814 14.1001 12.7028C13.8181 13.4906 13.6742 14.3212 13.6746 15.158V15.2045C13.5233 15.179 13.3706 15.1634 13.2173 15.158C10.4148 15.155 8.65998 18.1868 10.0586 20.6154C10.7091 21.7449 11.9138 22.4404 13.2173 22.439H29.5983C33.0966 22.4462 35.2908 18.6639 33.5479 15.6307C33.2179 15.0564 32.7664 14.5612 32.225 14.1798Z"
          stroke="#535353"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.2628 40.6943C24.6698 40.6943 27.4319 40.2852 27.4319 39.7807C27.4319 39.2762 24.6698 38.8672 21.2628 38.8672C17.8557 38.8672 15.0938 39.2762 15.0938 39.7807C15.0938 40.2853 17.8557 40.6943 21.2628 40.6943Z"
          fill="#C7C7C7"
        />
      </g>
      <defs>
        <clipPath id="clip0_4794_23156">
          <rect width="44" height="44" fill="white" transform="translate(0 0.890625)" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
